module.exports = __webpack_public_path__ + "img/logo_chapelco_sky.4aa9a4da.png";